
import React from "react";
import { components } from "react-select";
import wrapMenuList from "react-select-async-paginate/lib/wrap-menu-list";
import {Spinner} from "../../../components";

export const IndicatorsContainer = props => {
  return (
    <div style={{ color: 'var(--input-placeholder-color)' }}>
      <components.IndicatorsContainer {...props} />
    </div>
  );
};

export const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <i className="far fa-chevron-down d-flex"></i>
    </components.DropdownIndicator>
  );
};

export const IndicatorSeparator = ({ innerProps }) => {
  return <span className="d-none" {...innerProps} />;
};

export const LoadingIndicator = () => <Spinner timeout={1000} />

/**
 * specifically for react-select-async-paginate. For some reason they decided not to show the loading message
 * when paginating through results, (only shown when initially loading content)
 */

export const MenuList = wrapMenuList(({ children, ...props }) => {
  return <components.MenuList {...props} >
    {children}
    {/* append only when paginating, not on first request. Give it extra vertical space to make it easier to scroll ahead to the next page */}
    {props.isLoading && !!props.options.length && <div className={"my-3"}><components.LoadingMessage {...props} /></div>}
  </components.MenuList>
});


